import { Controller } from "@hotwired/stimulus"
import { LogoMotionPlayer, reducedMotionQuery } from "../modules/animated_logo_motion"

// Plays an inline animated logo's motion for one placement. The svg markup is
// site data, so its moving part is found by its [data-motion-part] contract
// rather than a Stimulus target. Runs only while the page is visible (and, for
// onlyInView placements, while the logo is on screen); nothing runs under
// prefers-reduced-motion, leaving the static svg as the rest pose.
export default class extends Controller {
  static values = { motion: Object }

  connect() {
    const part = this.element.querySelector("[data-motion-part]")
    this.reducedMotion = reducedMotionQuery()
    if (!part || typeof part.animate !== "function" || this.reducedMotion?.matches) return

    this.player = new LogoMotionPlayer(part, this.motionValue)
    this.inView = true
    this.sync = this.sync.bind(this)
    this.stop = this.stop.bind(this)
    document.addEventListener("visibilitychange", this.sync)
    this.reducedMotion?.addEventListener?.("change", this.stop)
    if (this.motionValue.onlyInView && "IntersectionObserver" in window) {
      this.inView = false
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries.some(entry => entry.isIntersecting)
        this.sync()
      })
      this.observer.observe(this.element)
    }
    this.sync()
  }

  disconnect() {
    this.stop()
  }

  sync() {
    if (!this.player) return
    if (this.inView && !document.hidden) this.player.play()
    else this.player.pause()
  }

  stop() {
    if (!this.player) return
    document.removeEventListener("visibilitychange", this.sync)
    this.reducedMotion?.removeEventListener?.("change", this.stop)
    this.observer?.disconnect()
    this.player.cancel()
    this.player = null
  }
}
